<template>
  <div class="find-pas container" :class="{height:codeshow}">
    <div class="wrapper">
      <a class="logo" href="http://www.tuling123.com/"></a>
      <div class="con-wrap">
        <div class="tit-box">
          <p class="tit active">
            找回密码
          </p>
        </div>
        <div class="wrong" :class="{active:errorMsg!==''}">{{errorMsg}} <router-link :to="{ name: 'register'}" v-if="errorMsg=='用户名不存在，'">快速注册？</router-link></div>
        <div>
          <input type="text" placeholder="手机号码/邮箱" v-model="telphone">
          <div class="yz">
            <input type="text" placeholder="验证码" v-model="code" class="yz-inp">
            <button class="yz-btn" @click="sendyzm">{{sendMsg}}</button>
          </div>
          <input type="password" placeholder="新密码" v-model="pass">
          <input type="password" placeholder="再次输入新密码" v-model="repass">
          <div class="jtocode" v-show="codeshow" ref="jcode"></div>
          <div class="login-btn" @click="sure">修改并登录</div>
          <div class="hrefs clearfix">
            <router-link :to="{ name: 'login'}"><span>返回登录</span></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../js/geetest.js';
  import mixin from '../../js/public.js';
  import $ from 'jquery';
  export default{
      mixins: [mixin],
      data () {
        return {
          errorMsg: '',
          id: '',
          code: '',
          pass: '',
          repass: '',
          sendMsg: '发送验证码',
          telphone: '',
          codeshow: false
        };
      },
      created () {
        this.id = this.uuid();
        this.$nextTick(function () {
          document.getElementsByTagName('title')[0].innerHTML = '找回密码';
        });
      },
      methods: {
        /* 验证手机号 */
        getJy () {
          var _this = this;
          if (this.$refs.jcode.innerHTML) {
            return;
          }
          $.ajax({
            url: _this.baseUrl + '/geetest/v3',
            type: 'POST',
            dataType: 'json',
            data: {id: _this.id},
            xhrFields: {
              withCredentials: true
            },
            success: function (res) {
              if (res.type === 'success') {
                window.initGeetest({
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.new_captcha,
                  product: 'popup',
                  width: '100%',
                  offline: !res.data.success
                }, _this.handlerPopup);
              }
            }
          });
        },
        sendyzm () {
          var phonetest = /^1[0-9]{10}$/;
          var emailtest = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-zd]{2,5}$/;
          var _this = this;
          if (this.sendMsg.length !== 5) {
            return;
          }
          if (!phonetest.test(this.telphone) && !emailtest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码或邮箱';
            return;
          }
          //  如果是邮箱
          if (emailtest.test(this.telphone)) {
            var url = '';
            var eml = '';
            var tel = '';
            url = _this.baseUrl + '/find/password/send/2';
            eml = _this.telphone;
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: {mobile: tel, email: eml},
                xhrFields: {
                  withCredentials: true
                },
                success: function (data) {
                  if (data.type === 'success') {
                    _this.errorMsg = '';
                    _this.toCode(tel);
                  } else if (data.code === 11140301 || data.code === 11140302) {
                    _this.errorMsg = '用户名不存在，';
                  } else {
                    _this.errorMsg = '操作频繁，请稍后再试';
                  }
                }
              });
          } else {
            this.getJy();
            this.codeshow = true;
            this.errorMsg = '请进行图片验证';
          }
        },
        /* 发送验证码 */
        toCode (txt) {
          var _this = this;
          var i = txt ? 60 : 270;
          this.sendMsg = i + '秒';
            var nu = setInterval(function () {
              i--;
              _this.sendMsg = i + '秒';
              if (i === 0) {
                clearInterval(nu);
                _this.sendMsg = '发送验证码';
              }
            }, 1000);
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onReady(function () {
            setTimeout(function () {
              document.getElementsByClassName('geetest_radar_btn')[0].click();
            }, 16);
          });
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            _this.errorMsg = '';
            setTimeout(function () {
              _this.codeshow = false;
            }, 1500);
            _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}).then(function (res) {
              if (res.body.type === 'success') {
                if (res.body.data) {
                  var url = '';
                  var tel = '';
                  var eml = '';
                  if (_this.telphone.indexOf('@') >= 0) {
                    url = _this.baseUrl + '/find/password/send/2';
                    eml = _this.telphone;
                  } else {
                    url = _this.baseUrl + '/find/password/send/1';
                    tel = _this.telphone;
                  }
                  $.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: tel, email: eml},
                    xhrFields: {
                      withCredentials: true
                    },
                    success: function (data) {
                      if (data.type === 'success') {
                        _this.errorMsg = '';
                        _this.toCode(tel);
                        captchaObj.reset();
                      } else {
                        _this.errorMsg = '操作频繁，请稍后再试';
                        captchaObj.reset();
                      }
                    }
                  });
                } else {
                  _this.errorMsg = '该账号不存在';
                  captchaObj.reset();
                }
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
            });

          });
        },
        /* 确定修改密码 */
        sure () {
          var _this = this;
          var re = /^\d+$/;
          var re1 = /^[a-zA-Z]+$/;
          var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
          var val = this.pass;
          var len = val.length;
          if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
            this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
            return;
          }
          if (this.pass !== this.repass) {
            this.errorMsg = '两次输入的密码不一样，请重新输入';
            return;
          }
          this.errorMsg = '';
          var url = '';
          var url2 = '';
          var tel = '';
          var eml = '';
          //  验证码
          if (_this.telphone.indexOf('@') >= 0) {
            url = _this.baseUrl + '/find/password/validate/2';
            eml = _this.telphone;
            url2 = this.baseUrl + '/find/password/modify/2';
          } else {
            url = _this.baseUrl + '/find/password/validate/1';
            tel = _this.telphone;
            url2 = _this.baseUrl + '/find/password/modify/1';
          }
          _this.$http.post(url, {mobile: tel, email: eml, code: _this.code}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              _this.$http.post(url2, {mobile: tel, email: eml, code: _this.code, password: this.pass}, {credentials: true}).then(function (res) {
                if (res.body.type === 'success') {
                  //  修改成功
                  window.location = _this.ReturnURl;
                } else {
                  _this.errorMsg = '修改密码失败，请检查账号是否正确';
                }
              }, function () {
                _this.errorMsg = '网络错误，请稍后再试';
              });
            } else {
              _this.errorMsg = '请输入正确的验证码';
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
          });
        },
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        }
      }
  };
</script>

<style lang="scss" scoped="" type="text/css">
  @import "../../css/public.scss";
  .tit-box{
    display: block;
  }
  .tit{
    margin-left: 20px;
    height: 50px;
  }
  .find-pas{
    height: 610px;
  }
  .find-pas.height{
    height: 660px;
  }
</style>



// WEBPACK FOOTER //
// findPas.vue?5b8d2458